import { render, staticRenderFns } from "./SkupTema2Details.vue?vue&type=template&id=c0a9e51e&scoped=true&"
import script from "./SkupTema2Details.vue?vue&type=script&lang=js&"
export * from "./SkupTema2Details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0a9e51e",
  null
  
)

export default component.exports